module.exports = __webpack_public_path__ + "static/media/ios-ribbon.04d3f464.svg";